import {
  Grid,
  GridItem,
  Box,
  Avatar,
  Wrap,
  WrapItem,
  Text,
  Stack,
  Divider,
  Flex,
  Button,
  IconButton,
} from '@chakra-ui/react'
import React, { memo, useMemo } from 'react'
import { BiFile } from 'react-icons/bi'
import { useNavigate } from 'react-router-dom'
import { truncateWithEllipsis } from 'utils/string-formatters'
import { CallRecording } from './call-recording'
import Chat from './chat'
import { useCallContact, useContactCenterModalEvents, useSelectedResidentContact } from './contact-center.hooks'
import { maskPhoneNumber } from './contact-center.utils'
import { PhoneIcon } from './dialer'
import { useCurrentPropertyId } from './dialer/dialer.hooks'
import { Transcription } from './transcription'

type LayoutChatRecordingType = {}
type ChatRecordingHeaderType = {}

export const LayoutChatRecording: React.FC<LayoutChatRecordingType> = memo(() => {
  return (
    <>
      <Box>
        <ChatRecordingHeader />
      </Box>
      <Grid templateColumns={['100%', '100%', '60% 40%']} gap={0} data-testid-="chat-recording-grid-layout">
        <GridItem>
          <Chat />
        </GridItem>
        <GridItem>
          <CallRecording />
          <Transcription />
        </GridItem>
      </Grid>
    </>
  )
})

export const ChatRecordingHeader: React.FC<ChatRecordingHeaderType> = memo(() => {
  const { selected } = useSelectedResidentContact()
  const { hide } = useContactCenterModalEvents()
  const navigate = useNavigate()
  
  const { callFunc } = useCallContact()

  const propertyId = useCurrentPropertyId()

  const viewPropertyDetails = () => {
    hide()
    navigate(`/property-details/${propertyId}`)
  }

  const handleCall = () => {
    callFunc.call(selected.phoneNumber)
  }

  const fullName = useMemo(() => {
    return truncateWithEllipsis(`${selected?.firstName} ${selected?.lastName}`, 100)
  }, [selected])
  return (
    <Box h="70px" borderBottom="2px solid #CBD5E0" p="2">
      <Flex ml="35px" position="relative" mt="2px" justifyContent="space-between">
        <Wrap spacing="15px">
          <WrapItem>
            <Avatar size="md" name={selected ? fullName : '---'} />
          </WrapItem>
          <WrapItem>
            <Stack>
              <Text color="gray.600" fontSize="12px" fontWeight="600">
                {selected ? fullName : '---'}
              </Text>
              <Text color="gray.700" fontSize="12px" fontWeight="400">
                {selected && maskPhoneNumber(selected.phoneNumber)}
              </Text>
            </Stack>
          </WrapItem>
          <WrapItem>
            <Box height="18px" position="relative" left="25px" top="16px">
              <Divider orientation="vertical" width="1px" backgroundColor="#CBD5E0" />
            </Box>
          </WrapItem>
          <WrapItem>
            <Box position="relative" left="50px" top="5px">
              <Button variant="outline" colorScheme="brand" leftIcon={<BiFile />} onClick={viewPropertyDetails}>
                Property Details
              </Button>
            </Box>
          </WrapItem>
        </Wrap>
        <Box w="100px">
          <IconButton
            aria-label="call"
            icon={<PhoneIcon   />}
            mt="10px"
            onClick={handleCall}
            maxW="34px"
            minW="34px"
            minH="34px"
            maxH="34px"
            borderRadius="full"
            bg="#345EA6"
          />
        </Box>
      </Flex>
    </Box>
  )
})
